import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { AssetRequest } from "types/AssetRequest";
import DialogShell from "./DialogShell";
import { MAX_TEXT_LENGTH } from "./asset-requests-helpers";

type Props = {
  request: AssetRequest;
  /** «Įvykdyta» takes an optional note; «Atmesti» needs a reason. */
  kind: "complete" | "reject";
  onSubmit: (text: string) => Promise<void>;
  onClose: () => void;
};

export default function ResolveDialog({ request, kind, onSubmit, onClose }: Props) {
  const { t } = useTranslation();
  const [text, setText] = useState("");
  const isReject = kind === "reject";

  return (
    <DialogShell
      title={isReject ? t("asset_requests_reject_title") : t("asset_requests_complete_title")}
      submitLabel={isReject ? t("asset_requests_reject") : t("asset_requests_mark_done")}
      submitDisabled={isReject && !text.trim()}
      danger={isReject}
      onSubmit={() => onSubmit(text.trim())}
      onClose={onClose}
    >
      <p className="text-sm text-gray-600">{t("asset_requests_for_employee", { name: request.employee.name ?? "—" })}</p>
      <label className="block text-sm font-medium text-gray-700">
        {isReject ? `${t("asset_requests_reject_reason")} *` : t("asset_requests_complete_note")}
        <textarea
          value={text}
          onChange={(event) => setText(event.target.value)}
          maxLength={MAX_TEXT_LENGTH}
          rows={3}
          autoFocus
          className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-base font-normal md:text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
        />
      </label>
    </DialogShell>
  );
}
